<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
    selectedTypeSlug() {
      if (!this.call.type || !this.types) return null;
      const found = this.types.find(t => t.id === this.call.type);
      return found ? found.slug : null;
    },
    canSendHuman() {
      return this.confirm.a && this.confirm.b && this.confirm.c;
    },
    canSendPet() {
      return !!this.call.petId;
    },
  },
  data() {
    return {
      step: 1,

      confirm: {
        a: false,
        b: false,
        c: false,
      },

      types: null,

      pets: null,
      petsLoading: false,
      petLimit: null,

      call: {
        type: "",
        petId: "",
        motive: "",
        loading: false,
      },
    };
  },
  methods: {
    getTypes() {
      this.types = null;

      api
        .get("telemedicina/plantao/tipos")
        .then((response) => {
          if (response.data.status == "success") {
            this.types = response.data.list;
          }
        });
    },
    setType(type) {
      this.call.type = type.id;
      this.call.petId = "";
      this.step = 2;

      this.confirm.a = false;
      this.confirm.b = false;
      this.confirm.c = false;

      if (type.slug === "pet" && this.pets === null) {
        this.loadPets();
      }
    },
    loadPets() {
      this.petsLoading = true;
      this.pets = null;
      this.petLimit = null;

      api
        .get("pets")
        .then((response) => {
          if (response.data.status === "success") {
            this.pets = response.data.list;
            this.petLimit = response.data.limit;
          }
        })
        .finally(() => {
          this.petsLoading = false;
        });
    },
    sendCall() {
      if (!this.call.type) return;

      this.step = 3;
      this.call.loading = true;

      const payload = { type: this.call.type };
      if (this.selectedTypeSlug === "pet") {
        payload.pet_id = this.call.petId;
      }

      api
        .post("telemedicina/plantao", payload)
        .then((response) => {
          if (response.data.status == "success") {
            const msg = this.selectedTypeSlug === "pet"
              ? "Atendimento veterinário solicitado com sucesso, você está sendo redirecionado."
              : "Plantão médico solicitado com sucesso, você está sendo redirecionado.";
            this.$toast.success(msg);
            window.location.href = response.data.url;
          } else {
            this.step = 2;
            this.call.loading = false;
            this.$toast.error("Não foi possível iniciar o atendimento, tente novamente.");
          }
        });
    },
  },
  mounted() {
    this.getTypes();
  }
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/telemedicina">Telemedicina</router-link></li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Plantão Médico 24h</h3>
        <p>Consulta rápida e eficiente com clínico geral</p>
      </div>
    </div>

    <b-progress :value="step" max="3" class="mb-5" variant="default"></b-progress>

    <div class="row justify-content-center">
      <div class="col-lg-6">
        <!-- Passo 1: Seleção do tipo -->
        <template v-if="step == 1">
          <h5 class="mb-4 text-center">Selecione o tipo de atendimento</h5>

          <div v-if="!types" class="text-center">
            <b-spinner variant="default" role="status"></b-spinner>
          </div>

          <div v-else-if="types && types.length == 0">
            <div class="card">
              <div class="card-body text-center">
                Nenhum tipo de atendimento encontrado.
              </div>
            </div>
          </div>

          <div v-else>
            <div class="card" v-for="(type, index) in types" :key="index">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    <h5 style="text-transform: capitalize;">{{ type.name }}</h5>
                    <p>{{ type.description }}</p>
                  </div>
                </div>
                <div>
                  <button class="btn btn-default btn-block btn-lg" v-on:click="setType(type)" :disabled="call.loading">
                    Escolher
                    <b-spinner v-if="call.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </template>

        <!-- Passo 2: Confirmações (human) ou seleção de pet -->
        <template v-if="step == 2">

          <!-- Fluxo Pet -->
          <template v-if="selectedTypeSlug === 'pet'">
            <h5 class="mb-4 text-center">Selecione o pet para atendimento</h5>

            <div v-if="petsLoading" class="text-center">
              <b-spinner variant="default" role="status"></b-spinner>
            </div>

            <div v-else-if="petLimit !== null && petLimit === 0" class="card">
              <div class="card-body text-center">
                <p class="mb-3">O seu plano não contempla o atendimento veterinário.</p>
                <button v-on:click="step = 1" class="btn btn-default btn-block btn-lg">
                  Voltar
                </button>
              </div>
            </div>

            <div v-else-if="pets !== null && pets.length === 0" class="card">
              <div class="card-body text-center">
                <p class="mb-3">Você ainda não possui pets cadastrados.</p>
                <router-link tag="a" to="/pets" class="btn btn-default btn-block btn-lg">
                  Cadastrar pet
                </router-link>
              </div>
            </div>

            <div v-else-if="pets !== null">
              <div
                class="card card-confirm"
                :class="{ 'bg-soft-success': call.petId === pet.id }"
                v-for="(pet, index) in pets"
                :key="index"
                v-on:click="call.petId = pet.id"
              >
                <div class="card-body d-flex align-items-center justify-content-between">
                  <div>
                    <strong>{{ pet.name }}</strong>
                    <span class="text-muted ml-2">{{ pet.breed }}</span>
                  </div>
                  <div class="ml-3">
                    <div v-if="call.petId === pet.id">
                      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" style="fill: rgba(53, 195, 147, 1);">
                        <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"></path>
                        <path d="M9.999 13.587 7.7 11.292l-1.412 1.416 3.713 3.705 6.706-6.706-1.414-1.414z"></path>
                      </svg>
                    </div>
                    <div v-else>
                      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" style="fill: rgba(210, 211, 229, 1);">
                        <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <button class="btn btn-default btn-block btn-lg mt-2" v-on:click="sendCall()" :disabled="!canSendPet || call.loading">
                  Solicitar atendimento
                  <b-spinner v-if="call.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
                </button>
              </div>
            </div>
          </template>

          <!-- Fluxo Human (padrão) -->
          <template v-else>
            <div class="card card-confirm" :class="{'bg-soft-success': confirm.a}" v-on:click="confirm.a = !confirm.a">
              <div class="card-body">
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    Fique em um local silencioso e iluminado para uma melhor experiência de atendimento.
                  </div>
                  <div class="ml-3">
                    <div v-if="confirm.a">
                      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" style="fill: rgba(53, 195, 147, 1);">
                        <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"></path>
                        <path d="M9.999 13.587 7.7 11.292l-1.412 1.416 3.713 3.705 6.706-6.706-1.414-1.414z"></path>
                      </svg>
                    </div>
                    <div v-else>
                      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" style="fill: rgba(210, 211, 229, 1);">
                        <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card card-confirm" :class="{ 'bg-soft-success': confirm.b }" v-on:click="confirm.b = !confirm.b">
              <div class="card-body">
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    Entendo que é minha responsabilidade a veracidade das informações fornecidas ao médico.
                  </div>
                  <div class="ml-3">
                    <div v-if="confirm.b">
                      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" style="fill: rgba(53, 195, 147, 1);">
                        <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"></path>
                        <path d="M9.999 13.587 7.7 11.292l-1.412 1.416 3.713 3.705 6.706-6.706-1.414-1.414z"></path>
                      </svg>
                    </div>
                    <div v-else>
                      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" style="fill: rgba(210, 211, 229, 1);">
                        <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card card-confirm" :class="{ 'bg-soft-success': confirm.c }" v-on:click="confirm.c = !confirm.c">
              <div class="card-body">
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    Compreendo que o profissional que me atender possui total autonomia para decidir se é necessária um receita médica ou atestado.
                  </div>
                  <div class="ml-3">
                    <div v-if="confirm.c">
                      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" style="fill: rgba(53, 195, 147, 1);">
                        <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"></path>
                        <path d="M9.999 13.587 7.7 11.292l-1.412 1.416 3.713 3.705 6.706-6.706-1.414-1.414z"></path>
                      </svg>
                    </div>
                    <div v-else>
                      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" style="fill: rgba(210, 211, 229, 1);">
                        <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <button class="btn btn-default btn-block btn-lg" v-on:click="sendCall()" :disabled="!canSendHuman">Avançar</button>
            </div>
          </template>
        </template>

        <template v-else-if="step == 3">
          <div class="text-center">
            <b-spinner variant="default" label="Aguarde..." />
          </div>
        </template>
      </div>
    </div>
  </Layout>
</template>

<style>
.card-confirm {
  cursor: pointer;
  -ms-user-select: none;
  -webkit-user-select: none;
  user-select: none;
}
.card-confirm.bg-soft-success {
  background-color: rgba(53, 195, 147, 0.1) !important;
  border-color: rgba(53, 195, 147, 0.3) !important;
}
</style>